import { render, staticRenderFns } from "./SeventhSection.vue?vue&type=template&id=23d95c65&scoped=true&"
import script from "./SeventhSection.vue?vue&type=script&lang=js&"
export * from "./SeventhSection.vue?vue&type=script&lang=js&"
import style0 from "./SeventhSection.vue?vue&type=style&index=0&id=23d95c65&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d95c65",
  null
  
)

export default component.exports